import React from 'react';
import { propOr } from 'ramda';
import { RTL_LANG } from '../constants/i18n';
import { determineLocale } from '../utils/determineLocale';
import IconBarChart from '@veneer/core/dist/scripts/icons/icon_bar_chart';
import { ThemeProvider, Toggle } from '@veneer/core';
import {
  ConsentToggleItem,
  ConsentToggleItemTitle,
  Container,
  ConsentToggleTitle,
  ConsentDescription,
  StyledToggle
} from '../styles/PSAPrivacySettingsStyle';

const PSAPrivacySettings = ({
  csData = {},
  alpacaData,
  psaProductSupportConsentToggle,
  setPSAProductSupportConsentToggle
}) => {
  const title = propOr('', 'title', csData);
  const body = propOr('', 'body', csData);
  const analyticToggleTitle = propOr('', 'analyticsTitle', csData);
  const supplementalText = propOr('', 'supplementalText', csData);
  const { language } = determineLocale();
  const isRTL = RTL_LANG.includes(language) ? true : false;
  let productSupport = '';

  if (alpacaData && typeof alpacaData === 'object') {
    Object.values(alpacaData).forEach((value) => {
      if (value?.purposeId?.includes('prodsupport')) {
        productSupport = value.verbiageValue || '';
      }
    });
  }

  return (
    <Container isRTL={isRTL}>
      <div className="body-large">{title}</div>
      <body>
        <p dangerouslySetInnerHTML={{ __html: body }} isRTL={isRTL} />
      </body>
      <ConsentToggleItem>
        <ConsentToggleItemTitle>
          <ConsentToggleTitle>
            <IconBarChart />
            <span className="body">{analyticToggleTitle}</span>
          </ConsentToggleTitle>
          <ThemeProvider density="high">
            {productSupport && <StyledToggle
              id="product-support-consent-toggle"
              on={psaProductSupportConsentToggle}
              onChange={(e) => {
                setPSAProductSupportConsentToggle(e);
              }}
            />}
          </ThemeProvider>
        </ConsentToggleItemTitle>
        <ConsentDescription>
          <body>{productSupport}</body>
        </ConsentDescription>
      </ConsentToggleItem>

      <body>
        <p dangerouslySetInnerHTML={{ __html: supplementalText }} isRTL={isRTL} />
      </body>
    </Container>
  );
};

export default PSAPrivacySettings;
